import { useCallback } from 'react';
import { useMutation } from 'src/graphql';
import {
  CREATE_COUNTRY_LANGUAGE_MUTATION,
  UPDATE_COUNTRY_LANGUAGE_MUTATION,
} from 'src/graphql/countryLanguage/mutation';

export default isNew => {
  const mutation = isNew
    ? CREATE_COUNTRY_LANGUAGE_MUTATION
    : UPDATE_COUNTRY_LANGUAGE_MUTATION;
  const [upsertCountryLanguage] = useMutation(mutation);

  return useCallback(
    (params) =>
    upsertCountryLanguage({
        variables: params,
      }),
    [],
  );
};
